import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import './quasar'
import axios from 'axios'
import Vue2Filters from 'vue2-filters'
import JsonExcel from 'vue-json-excel'
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

Vue.use(VueFlatPickr);
Vue.use(Vue2Filters)
Vue.component('downloadExcel', JsonExcel)

Vue.prototype.$http = axios.create({
  // baseURL: "http://localhost/ppid-big/public/api",
  baseURL: "https://ppid.big.go.id/api",
});

// menggunakan locale id pada moment js
const moment = require('moment')
require('moment/locale/id')

Vue.use(require('vue-moment'), {
    moment
})
// Vue.use(require('vue-moment'));

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
